import { combineReducers } from '@reduxjs/toolkit';

const createRootReducer = () => {
    return combineReducers({
    });
};

export default createRootReducer;